import React from "react";

import FolderIcon from "../../assets/Icons/Folder Icon Orange.png";

// `actions`: optional buttons shown next to the title
const HeaderWithBreadcrumb = ({ title = "Company Master", breadcrumb, actions }) => {
  return (
    <div className="flex items-center justify-between mb-3 mt-2 gap-3 flex-wrap">
      <div className="flex items-center gap-3 flex-wrap">
        <p className="text-[#2E237F] text-lg font-semibold">{title}</p>
        {actions}
      </div>

      <div className="flex gap-[3px] items-center">
        <img
          src={FolderIcon}
          alt="folder icon"
          className="w-[13px] h-3 mr-[3px]"
        />
        <span className="text-xs font-normal text-[#FF702B]">/</span>
        <span className="text-xs font-medium text-[#FF702B]">
          {breadcrumb}
        </span>
        <span className="text-xs font-normal text-[#FF702B]">/</span>
        <span className="text-xs font-medium text-[#FF702B]">{title}</span>
      </div>
    </div>
  );
};

export default HeaderWithBreadcrumb;
